import { render, staticRenderFns } from "./QuickTipsDuplicateGroupDetails.vue?vue&type=template&id=b96a8eb2&scoped=true&"
import script from "./QuickTipsDuplicateGroupDetails.vue?vue&type=script&lang=js&"
export * from "./QuickTipsDuplicateGroupDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96a8eb2",
  null
  
)

export default component.exports